import {IconProps} from './types';

function AiAgentFileIcon({stroke = '#B1B1B1', width = 20, height = 20, className}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16.7143 19.5714"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                d="M16.2143 17.6429C16.2143 18.0217 16.0637 18.3851 15.7959 18.653C15.528 18.9209 15.1646 19.0714 14.7857 19.0714H1.92857C1.54969 19.0714 1.18633 18.9209 0.918414 18.653C0.650514 18.3851 0.5 18.0217 0.5 17.6429V1.92857C0.5 1.54969 0.650514 1.18633 0.918414 0.918419C1.18633 0.65051 1.54969 0.5 1.92857 0.5H11.2143L16.2143 5.5V17.6429Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 0.5V6.21429H16.2143"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default AiAgentFileIcon;
